export default {
    checkInTimeError: 'SOMETHING WENT WRONG',
    close: 'Close'
}
